<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaFurnizor')}}</h4>
        </div>
        <form class="add-user-form" id='edit-provider' method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="type-person">
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.tipulDePersoana')}} </h4>
                    </div>
                    <div class="col-12">
                        <label class="container_check">

                            <input type="radio" value="1" name="type" v-model="type_provider">
                            <span class="checkmark"></span>
                            {{$t('txt.persFizica')}}
                        </label>
                    </div>
                    <div class="col-12">
                        <label class="container_check">
                            <input type="radio" value="2" name="type" v-model="type_provider">
                            <span class="checkmark"></span>
                            {{$t('txt.persJuridica')}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                         <div class="inputfield-wrapper" v-if="!input_field.personType || parseInt(input_field.personType) === parseInt(type_provider)">
                           <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :name="input_field.inputName"
                                   v-model="input_field.inputValue"
                                   :data-vv-as="input_field.labelName"
                                   :id="input_field.inputName">
                           <label class=""> {{input_field.labelName}} </label>
                           <span class="focus-input"></span>
                           <span class="symbol-input">
                             <i v-bind:class="input_field.icon"></i>
                           </span>
                           <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                         </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label == 1}">Alege Judetul </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label == 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_county"
                                      :options="counties"
                                      label="name"
                                      @input="getCitiesByCounty()">
                            </v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 2">
                            <label :class="{select_label_class:selected_label == 2}"> Alege Orasul </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label == 2}">
                                <i class="fas fa-city"></i>
                            </div>
                                <v-select v-model="select_city"
                                          :options="cities"
                                          label="name">
                                </v-select>
                        </div>
                        <div v-else>
                            <input type="text"
                                   class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :name="input_field.inputName"
                                   :data-vv-as="input_field.labelName"
                                   :id="input_field.inputName"
                                   v-model="input_field.inputValue">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                        </div>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div v-if="!this.has_account" class="alert-checkbox-container">
                    <label class="alert-checkbox">
                            <input type="checkbox" value='1' name="create_account">
                            <span class="checkbox-material">
                            <span class="check"></span>
                        </span>
                        <p> {{$t('txt.creeazaCont')}} </p>
                    </label>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.locatii')}} </h4>
                    </div>
                </div>
                <transition name="fade" mode="out-in">
                    <div class="col-12" v-if="!locationStatus" key="1">
                        <div class="location-wrapper" id="location-id">
                            <div class="location-wrapper-inner">
                                <sequential-entrance fromTop delay="10" v-if='this.provider'>
                                    <div class="location-box" v-for="(location, index) in this.provider.locations" :key="index">
                                        <ul class="location-inner-list">
                                            <div class="delete-location" @click="removeLocation(index, location.id)">
                                                <i class="far fa-trash-alt"></i>
                                            </div>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.denumireLocatie')}}
                                                </h4>
                                                <p>
                                                    {{ location.name ? location.name : '-'}}
                                                </p>
                                            </li>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.adresa')}}
                                                </h4>
                                                <p>
                                                    {{ fullAddress(location) }}
                                                </p>
                                            </li>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.linkGoogleMaps')}}
                                                </h4>
                                                <p>
                                                    {{ location.link_map ? location.link_map : '-'}}
                                                </p>
                                            </li>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.persoanaContact')}}
                                                </h4>
                                                <p>
                                                    {{ location.contact_pers ? location.contact_pers : '-'}}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="location-buttons animated-form-buttons">
                                        <div class="new-location">
                                            <button type="button" id="scrollerBtn"
                                                    v-on:click="locationStatus = !locationStatus">
                                                <i class="fas fa-plus-circle"></i>
                                                {{$t('txt.creeazaLocatie')}}
                                            </button>
                                        </div>
                                    </div>
                                </sequential-entrance>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12" v-else key="2">
                        <div class="inner-location-group">
                            <div class="form-group" v-for="input_field in input_fields.location" :key="input_field.id">
                                <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 3">
                                    <label :class="{select_label_class:selected_label === 3}"> {{$t('placeholder.judet')}} </label>
                                    <div class="symbol-input" :class="{symbol_input_class:selected_label === 3}">
                                        <i :class="input_field.icon"></i>
                                    </div>
                                    <v-select v-model="input_field.inputValue" :options="counties" label="name"
                                              @input="getCitiesByCountyLocation()"></v-select>
                                </div>
                                <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 4">
                                    <label :class="{select_label_class:selected_label === 4}"> {{$t('placeholder.oras')}} </label>
                                    <div class="symbol-input" :class="{symbol_input_class:selected_label === 4}">
                                        <i :class="input_field.icon"></i>
                                    </div>
                                    <v-select v-model="input_field.inputValue" :options="cities_location" label="name"></v-select>
                                </div>
                                <div v-else>
                                    <input type="text"
                                           class="form-control"
                                           placeholder=""
                                           v-validate="input_field.validationRules"
                                           :name="input_field.inputName"
                                           :data-vv-as="input_field.labelName"
                                           v-model="input_field.inputValue"
                                    >
                                    <label class=""> {{input_field.labelName}} </label>
                                    <span class="focus-input"></span>
                                    <span class="symbol-input">
                                        <i v-bind:class="input_field.icon"></i>
                                    </span>
                                    <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                                </div>
                            </div>
                            <div class="location-buttons animated-form-buttons">
                                <div class="location-button">
                                    <button type="button" class="see-location-button"
                                            @click="locationStatus = !locationStatus">
                                        <i class="fas fa-eye"></i>
                                        {{$t('txt.veziLocatii')}}
                                    </button>
                                </div>
                                <div class="location-button">
                                    <button type="button" @click="saveLocation()">
                                        <i class="fas fa-check"></i>
                                        {{$t('txt.salveazaLocatia')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.persoanaContact')}} </h4>
                    </div>
                </div>
                <transition name="fade" mode="out-in">
                    <div class="col-12" v-if="!contactStatus">
                        <div class="contact-person-wrapper" id="contact-id">
                            <div class="contact-wrapper-inner" id="contact-list-container">
                                <sequential-entrance fromTop delay="10" v-if='this.provider'>
                                    <div class="contact-person-box" v-for="(contact, index) in this.provider.contacts" :key="index">
                                        <ul class="contact-inner-list">
                                            <div class="delete-contact" @click='removeContact(index, contact.id)'>
                                                <i class="far fa-trash-alt"></i>
                                            </div>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.nume')}}
                                                </h4>
                                                <p>
                                                    {{ contact.name ? contact.name : '-'  }}
                                                </p>
                                            </li>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.functie')}}
                                                </h4>
                                                <p>
                                                    {{ contact.function ? contact.function : '-'  }}
                                                </p>
                                            </li>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.email')}}
                                                </h4>
                                                <p>
                                                    {{ contact.email ? contact.email : '-'  }}
                                                </p>
                                            </li>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.telefon')}}
                                                </h4>
                                                <p>
                                                    {{ contact.phone ? contact.phone : '-'  }}
                                                </p>
                                            </li>
                                            <li>
                                                <h4>
                                                    {{$t('placeholder.notite')}}
                                                </h4>
                                                <p>
                                                    {{ contact.notes ? contact.notes : '-'  }}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="contact-add-button" id="contact-button-create-container">
                                        <div class="new-contact-button">
                                            <button type="button" v-on:click="contactStatus = !contactStatus">
                                                <i class="fas fa-plus-circle"></i>
                                                    {{$t('txt.adaugaContact')}}
                                            </button>
                                        </div>
                                    </div>
                                </sequential-entrance>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12" v-else>
                        <div class="create-contact-wrapper">
                            <div v-for="input_field in input_fields.contact" :key="input_field.id">
                                <div v-if="input_field.inputName != 'notes'" class="form-group">
                                    <input type="text"
                                           class="form-control"
                                           placeholder=""
                                           v-validate="input_field.validationRules"
                                           v-bind:name="input_field.inputName"
                                           :data-vv-as="input_field.labelName"
                                           v-model="input_field.inputValue">
                                    <label class=""> {{input_field.labelName}} </label>
                                    <span class="focus-input"></span>
                                    <span class="symbol-input">
                                        <i v-bind:class="input_field.icon"></i>
                                    </span>
                                    <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                                </div>
                                <div  v-else class="create-contact">
                                    <textarea :placeholder="input_field.labelName" v-model="input_field.inputValue" :name="input_field.inputName"></textarea>
                                </div>
                            </div>

                            <div class="contact-add-button">
                                <div class="see-contact-button" id="see-contact-button">
                                    <button type="button" v-on:click="contactStatus = !contactStatus">
                                        <i class="fas fa-eye"></i>
                                        {{$t('txt.veziContacte')}}
                                    </button>
                                </div>
                                <div class="save-contact-button">
                                    <button type="button" @click="saveContact()">
                                        <i class="fas fa-check"></i>
                                        {{$t('txt.salveazaContact')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.selecteazaTipFurnizor')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <subtypes :subtypes="providersSubtypes"></subtypes>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.documente')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div class="inner-location-group doc-group">
                        <b-form-file
                                name="files[]"
                                v-model="file"
                                ref="file-input"
                                :state="Boolean(file)"
                                placeholder="Alege Fisierul..."
                                drop-placeholder="Drop file here..."
                                id='file'
                                multiple
                        ></b-form-file>
                        <div class="documents-list" v-if="this.provider">
                            <div class="document-box" v-for="(file, index) in this.provider.files" :key="index">
                                <div class="delete-doc" @click='removeMedia(index, file.id)'>
                                    <i class="far fa-times-circle"></i>
                                </div>
                                <div class="document-content">
                                    <i class="far fa-file-alt"></i>
                                    <section v-if="mimes.includes(file.mime)">
                                        <a v-bind:href="file.link" target="_blank"> {{ file.file_name }} </a>
                                    </section>
                                    <section v-else>
                                        <a :href="file.link" download> {{ file.file_name }} </a>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea v-model="this.notes" :placeholder="$t('placeholder.notite')" name='notes'></textarea>
                        <div class="save-contact-buttons">
                            <button type="button" @click='saveProvider()'>
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ProvidersService from '../../api-services/providers.service.js'
import CountiesService from '../../api-services/counties.service.js'
import LocationsService from '../../api-services/locations.service.js'
import ContactsService from '../../api-services/contacts.service.js'
import UsersService from '../../api-services/users.service.js'
import Subtypes from '../subtypes/Subtypes.vue'
import localforage from 'localforage'
export default {
  name: 'Editprovider',
  data () {
    return {
      provider: {
        id: null,
        type: null,
        first_name: null,
        last_name: null,
        company_name: null,
        email: null,
        phone: null,
        county: null,
        city: null,
        address: null,
        cui: null,
        nr_reg: null,
        bank: null,
        site: null,
        delegat: null,
        date_corespondenta: null,
        notes: null,
        has_account: null,
        is_transformed_in_contact: null,
        locations: null,
        contacts: null,
        files: null
      },
      type_provider: null,
      has_account: true,
      notes: null,
      selected_label: undefined,
      file: null,
      mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
      locationStatus: false,
      contactStatus: false,
      counties: [],
      cities: [],
      cities_location: [],
      select_county: null,
      select_city: null,
      post_data: [],
      selected: null,
      providersSubtypes: []
    }
  },
  components: {
    'subtypes': Subtypes
  },
  methods: {
    clearFiles () {
      this.$refs['file-input'].reset()
    },
    getProvider () {
      return new Promise((resolve, reject) => {
        ProvidersService.get(this.$route.params.id)
          .then((response) => {
            this.provider = response.data.data
            this.type_provider = this.provider.type
            this.has_account = this.provider.has_account
            this.notes = this.provider.notes
            this.$store.dispatch('hideLoading')
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    getCounties () {
      return localforage.getItem('counties').then((response) => {
        this.counties = response
        if (this.provider.county) {
          this.select_county = this.counties.find(county => parseInt(county.id) === parseInt(this.provider.county.id))
          this.getCitiesByCounty()
        }
      })
    },
    getCitiesByCounty () {
      let countyId = this.select_county.id
      if (countyId && countyId > 0) {
        return localforage.getItem('cities').then((response) => {
          this.cities = response
          if (this.provider.city) {
            this.select_city = this.cities.find(city => parseInt(city.id) === parseInt(this.provider.city.id))
          }
        })
      }
    },
    getCitiesByCountyLocation () {
      let county = this.input_fields.location.find(county => county.inputName === 'county')
      let city = this.input_fields.location.find(city => city.inputName === 'city')
      if (county) {
        let countyId = (county.inputValue) ? county.inputValue.id : null
        this.cities_location = []
        city.inputValue = null
        if (countyId && countyId > 0) {
          CountiesService.get(countyId)
            .then((response) => {
              this.cities_location = response.data.data.cities
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    getProviderSubtypes () {
      ProvidersService.getTypes()
        .then((response) => {
          this.providersSubtypes = response.data.data
          for (let i = 0; i < this.providersSubtypes.length; i++) {
            let providerSubtype = this.provider.user_type.find(providerType => parseInt(providerType.type_id) === this.providersSubtypes[i].id)
            if (providerSubtype) {
              this.providersSubtypes[i].value = true
            } else {
              this.providersSubtypes[i].value = false
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async saveProvider () {
      let validatorResp = true
      await this.$validator.validateAll().then((result) => {
        validatorResp = result
        if (this.$validator.errors && !result) {
          let input = document.getElementById(this.$validator.errors.items[0].field)
          window.scrollTo(0, input.offsetTop - 50)
        }
      })
      if (!validatorResp) {
        return
      }
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-provider'))

      if (this.select_county) {
        formData.append('county', this.select_county.id)
      }
      if (this.select_city) {
        formData.append('city', this.select_city.id)
      }
      formData.append('subtypes', JSON.stringify(this.providersSubtypes))
      ProvidersService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.provider = response.data.data
          document.getElementById('file').value = ''
          this.$refs['file-input'].reset()
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.furnizorModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    },
    saveLocation () {
      let locationObj = {}
      this.input_fields.location.forEach(function (element) {
        if (element.inputName === 'county' || element.inputName === 'city') {
          if (element.inputValue) {
            locationObj[element.inputName] = element.inputValue.id
          }
        } else {
          locationObj[element.inputName] = element.inputValue
        }
      })

      ProvidersService.addLocation(this.$route.params.id, locationObj)
        .then((response) => {
          this.provider.locations.push(response.data.data)
          this.locationStatus = !this.locationStatus
          this.input_fields.location.forEach(function (element) {
            element.inputValue = null
          })
          this.cities_location = []
        })
        .catch((error) => {
          console.log(error)
        })
    },
    saveContact () {
      let contactObj = {}
      this.input_fields.contact.forEach(function (element) {
        contactObj[element.inputName] = element.inputValue
      })
      ProvidersService.addContact(this.$route.params.id, contactObj)
        .then((response) => {
          this.provider.contacts.push(response.data.data)
          this.contactStatus = !this.contactStatus
        })
        .catch((error) => {
          console.log(error)
        })
    },
    removeLocation (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeLocatia'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          LocationsService.delete(id)
            .then((response) => {
              this.$delete(this.provider.locations, index)
              this.$notify({
                group: 'succes',
                type: 'success',
                title: 'DELETED',
                text: 'Locatia a fost stearsa cu succes!',
                'animation-type': 'css'
              })
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    removeContact (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeContactul'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          ContactsService.delete(id)
            .then((response) => {
              this.$delete(this.provider.contacts, index)
              this.$notify({
                group: 'succes',
                type: 'success',
                title: 'DELETED',
                text: 'Contactul a fost sters cu succes!',
                'animation-type': 'css'
              })
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    removeMedia (index, mediaId) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeFisierul'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          UsersService.delete(this.$route.params.id, mediaId)
            .then((response) => {
              this.$delete(this.provider.files, index)
              this.$notify({
                group: 'succes',
                type: 'success',
                title: 'DELETED',
                text: 'Fisiserul a fost stears cu succes!',
                'animation-type': 'css'
              })
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.provider) ? this.provider.first_name : '',
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: (this.provider) ? this.provider.last_name : '',
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: null,
            icon: 'far fa-id-card',
            validationRules: 'min:13|max:13|numeric',
            personType: 1,
            inputType: 'number'
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            inputValue: null,
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            inputValue: null,
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.provider) ? this.provider.company_name : '',
            icon: 'fas fa-building',
            validationRules: 'required',
            personType: 2
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.provider) ? this.provider.phone : '',
            icon: 'fas fa-phone',
            validationRules: ''
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: (this.provider) ? this.provider.cui : '',
            icon: 'fas fa-scroll',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.provider) ? this.provider.nr_reg : '',
            icon: 'fas fa-cash-register',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: (this.provider) ? this.provider.bank : '',
            icon: 'fas fa-piggy-bank',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.provider) ? this.provider.county : null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: (this.provider) ? this.provider.city : null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.provider) ? this.provider.address : '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.provider) ? this.provider.email : '',
            icon: 'fas fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'delegat',
            labelName: this.$t('placeholder.delegat'),
            inputValue: (this.provider) ? this.provider.delegat : '',
            icon: 'fas fa-user-tie',
            validationRules: ''
          },
          {
            inputName: 'date_corespondenta',
            labelName: this.$t('placeholder.dateDeCorespondenta'),
            inputValue: (this.provider) ? this.provider.date_corespondenta : '',
            icon: 'fas fa-info',
            validationRules: ''
          },
          {
            inputName: 'site',
            labelName: this.$t('placeholder.siteWeb'),
            inputValue: (this.provider) ? this.provider.site : '',
            icon: 'far fa-window-maximize',
            validationRules: ''
          }
        ],
        location: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumireLocatie'),
            inputValue: '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: null,
            icon: 'fas fa-city',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'link_map',
            labelName: this.$t('placeholder.linkGoogleMaps'),
            inputValue: '',
            icon: 'fas fa-map-marked',
            validationRules: ''
          },
          {
            inputName: 'contact_pers',
            labelName: this.$t('placeholder.persoanaContact'),
            inputValue: '',
            icon: 'fas fa-users-cog',
            validationRules: ''
          }
        ],
        contact: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.nume'),
            inputValue: '',
            icon: 'fas fa-signature',
            validationRules: ''
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: '',
            icon: 'fas fa-phone',
            validationRules: ''
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: '',
            icon: 'fa fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'function',
            labelName: this.$t('placeholder.functie'),
            inputValue: '',
            icon: 'far fa-id-badge',
            validationRules: ''
          },
          {
            inputName: 'notes',
            labelName: this.$t('placeholder.notite'),
            inputValue: '',
            icon: '',
            validationRules: ''
          }
        ]
      }
    }
  },
  async created () {
    await this.getProvider()
    this.getProviderSubtypes()
    this.getCounties()
  }
}
</script>
